import { useRef, useState, useEffect } from 'react';
const DrawingPage = () => {
    
    const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [context, setContext] = useState(null);

  // Boundary settings (the area where the user can sign)
  const boundary = { x: 50, y: 50, width: 700, height: 300 };

  // Initialize canvas context
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    setContext(ctx);
    ctx.lineWidth = 3;
    ctx.lineCap = 'round';
    ctx.strokeStyle = 'black';
  }, []);

  // Start drawing on pointer down
  const startDrawing = (e) => {
    const { offsetX, offsetY } = e.nativeEvent;
    if (context && isInsideBoundary(offsetX, offsetY)) {
      context.beginPath();
      context.moveTo(offsetX, offsetY);
      setDrawing(true);
    }
  };

  // Drawing on pointer move
  const draw = (e) => {
    if (!drawing) return;
    const { offsetX, offsetY } = e.nativeEvent;
    if (context && isInsideBoundary(offsetX, offsetY)) {
      context.lineTo(offsetX, offsetY);
      context.stroke();
    }
  };

  // Stop drawing on pointer up or leave
  const stopDrawing = () => {
    if (context) {
      context.closePath();
    }
    setDrawing(false);
  };

  // Check if the pointer is inside the signature boundary
  const isInsideBoundary = (x, y) => {
    return x >= boundary.x && x <= boundary.x + boundary.width && y >= boundary.y && y <= boundary.y + boundary.height;
  };

  // Draw the boundary for the signature area
  const drawBoundary = (ctx) => {
    ctx.strokeStyle = '#999';
    ctx.lineWidth = 2;
    ctx.strokeRect(boundary.x, boundary.y, boundary.width, boundary.height);
  };

  // Move the cursor to the start of the boundary when pointer enters the canvas
  const handlePointerEnter = () => {
    const canvas = canvasRef.current;
    // Programmatically move the cursor to the start area of the canvas
    canvas.style.cursor = 'crosshair'; // You can change this to any cursor style you want
    const ctx = canvas.getContext('2d');
    ctx.moveTo(boundary.x, boundary.y); // This moves the initial drawing point to the start area
  };


  const clearSignature = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawBoundary(ctx); // Redraw boundary after clearing
  };

  const saveSignature = () => {
    const dataUrl = canvasRef.current.toDataURL();
    console.log(dataUrl); // This gives the base64 image data
  };


    return ( 
        <>
            <div className="container-xxl flex-grow-1 container-p-y">
                <h1>React Drawing App with XP Pen Tablet</h1>
                <canvas
                    className=' border border-danger'

        ref={canvasRef}
        width={800}
        height={600}
        onPointerDown={startDrawing}
        onPointerMove={draw}
        onPointerUp={stopDrawing}
        onPointerLeave={stopDrawing}
        onPointerEnter={handlePointerEnter} // Handle pointer entering the canvas
        style={{
          border: '1px solid #000',
          cursor: 'auto', // Default cursor, but we change it onPointerEnter
        }}/>

                <button className='btn btn-primary' onClick={clearSignature}>
                    Clear
                </button>
                <button className='btn btn-primary' onClick={saveSignature}>
                    Save
                </button>
            </div>
        </>
     );
}
 
export default DrawingPage;